export default "__VITE_ASSET__yNwxZHmZ__"